import { useCallback, useEffect, useRef, useState } from 'react';

export const useCountdown = (
  segundos: number
): { restante: number; expirado: boolean; restart: () => void } => {
  const prazo = useRef(Date.now() + segundos * 1000);
  const [restante, setRestante] = useState(segundos);

  useEffect(() => {
    const calcular = (): void => {
      const faltam = Math.max(
        0,
        Math.ceil((prazo.current - Date.now()) / 1000)
      );
      setRestante(faltam);
    };

    const intervalo = setInterval(calcular, 250);
    calcular();

    return () => clearInterval(intervalo);
  }, []);

  const restart = useCallback((): void => {
    prazo.current = Date.now() + segundos * 1000;
    setRestante(segundos);
  }, [segundos]);

  return { restante, expirado: restante === 0, restart };
};

export const formatarRestante = (segundos: number): string => {
  if (segundos >= 60) {
    const minutos = Math.ceil(segundos / 60);
    return `${minutos} minuto${minutos > 1 ? 's' : ''} restante${
      minutos > 1 ? 's' : ''
    }`;
  }
  return `${segundos} segundo${segundos === 1 ? '' : 's'} restante${
    segundos === 1 ? '' : 's'
  }`;
};
